export default __webpack_public_path__ + "static/media/NHPLogo_new1.e7c54790.webp";